import * as React from "react";
const SvgFiRrShipSide = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ship-side_svg__a)">
      <path
        fill="#062147"
        d="M19.989 12h-1.336a15.7 15.7 0 0 0-4.328-5.864A5.03 5.03 0 0 0 11.146 5H8.818L8.11 2.315A3.108 3.108 0 1 0 2.1 3.9L2.394 5H1a1 1 0 1 0 0 2h10.146a3.03 3.03 0 0 1 1.913.687 13.4 13.4 0 0 1 3.386 4.318h-.82a3.04 3.04 0 0 0-1.692.5l-1.984 1.322A1 1 0 0 1 11.4 14H1a1 1 0 0 0 0 2h10.4a3 3 0 0 0 1.664-.5l1.983-1.322a.95.95 0 0 1 .574-.168h4.369a2 2 0 0 1 1.7.935 1.95 1.95 0 0 1 .123 1.912A9.03 9.03 0 0 1 13.668 22H1a1 1 0 0 0 0 2h12.668a11.04 11.04 0 0 0 9.948-6.3 4 4 0 0 0-3.627-5.7M4.037 3.388a1.107 1.107 0 0 1 2.14-.564L6.75 5H4.462zM0 10a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1m4 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ship-side_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShipSide;
